
import { useTranslation } from "react-i18next";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import FeaturedTherapists from "@/components/FeaturedTherapists";
import PartnerOrganizations from "@/components/PartnerOrganizations";
import Testimonials from "@/components/Testimonials";
import ComparisonSection from "@/components/ComparisonSection";
import PortalButtons from "@/components/PortalButtons";
import Footer from "@/components/Footer";

import { useFeaturedPractitioners } from "@/hooks/useFeaturedPractitioners";
import { OrganizationSEO } from "@/components/seo/OrganizationSEO";

const Index = () => {
  const { t } = useTranslation('home');
  const { practitioners, loading, error } = useFeaturedPractitioners();

  return (
    <div className="min-h-screen flex flex-col">
      <OrganizationSEO />
      <Navbar />
      <main className="flex-grow">
        <HeroSection />
        
        {loading ? (
          <section className="py-12 bg-white">
            <div className="container mx-auto px-4">
              <h2 className="text-3xl font-display font-semibold text-warm-800 mb-8 text-center">
                {t('featuredPractitionersTitle')}
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {[1, 2, 3].map((i) => (
                  <div
                    key={i}
                    className="h-48 bg-gray-200 rounded animate-pulse"
                  ></div>
                ))}
              </div>
            </div>
          </section>
        ) : error ? (
          <section className="py-12 bg-white">
            <div className="container mx-auto px-4">
              <h2 className="text-3xl font-display font-semibold text-warm-800 mb-8 text-center">
                {t('featuredPractitionersTitle')}
              </h2>
              <div className="text-center text-warm-500">
                <p>{t('loadError')}</p>
              </div>
            </div>
          </section>
        ) : (
          <FeaturedTherapists therapists={practitioners} />
        )}

        <PartnerOrganizations />
        <Testimonials />
        <ComparisonSection />
        <PortalButtons />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
